import React from "react";
import LeadContactAndBilling from "./LeadContactAndBilling";
import LeadDropDowns from "./LeadDropDowns";
import LeadCustomFields from "./LeadCustomFields";
import Spinner from "components/Spinner";

export default function LeadAdvanceSearchForm({
  showModal,
  formData,
  setFormData,
  loading,
  handleSearch,
  saveRequest,
}) {
  const handleInputChange = (event, type) => {
    const { name, value } = event.target;
    saveRequest(name, type === "number" ? parseInt(value) : value);
  };

  return (
    <div>
      {loading && <Spinner />}

      <div>
        <h4 className="border-bottom border-2 d-inline-block mb-1 pe-2">
          Lead Contact & Billing
        </h4>
        <LeadContactAndBilling
          formData={formData}
          setFormData={setFormData}
          handleInputChange={handleInputChange}
        />

        <h4 className="border-bottom border-2 d-inline-block mb-1 pe-2 mt-3">
          Lead General Details & Custom Fields
        </h4>
        <div className="row bg-white custom-border-radius-sm custom-shadow mx-1">
          <LeadDropDowns
            formData={formData}
            setFormData={setFormData}
            handleInputChange={handleInputChange}
          />
          <LeadCustomFields
            formData={formData}
            setFormData={setFormData}
            handleInputChange={handleInputChange}
          />
        </div>
      </div>
      <div className="d-flex justify-content-end mt-3 gap-1">
        <button
          onClick={() => {
            showModal(false);
          }}
          className="btn btn-secondary"
        >
          Close
        </button>

        <button onClick={handleSearch} className="btn btn-primary">
          Search
        </button>
      </div>
    </div>
  );
}
